export const CREDIT_CARD = 'credit_debit';
export const REBOOT = 'reboot';
export const ON = 'on';
export const OFF = 'off';
export const VS_INSTANCE_STATUS = 'vs_instance_status';
export const restore_backup = 'restore_backup';
export const save_backup = 'save_backup';
